import React, { Component } from 'react';

import logger from '~src/services/logger/LlsLogger';
import { SideBarWrapper } from '~src/shared/sidebar/styles/sidebar.sc';

import Sidebar from './Sidebar';

interface State {
  error: any;
}

class SidebarError extends Component<{}, State> {
  state = {
    error: null,
  };

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logger.error('FE ERROR', { error, info });
    this.setState({
      error: {
        errorMsg: error,
        infoMsg: info,
        location: 'sidebar',
      },
    });
  }

  render() {
    const errorReload = () => window.location.reload();
    return (
      <>
        {!this.state.error ? (
          <Sidebar />
        ) : (
          <SideBarWrapper data-testid="sidebar__wrapper">
            {/*tslint:disable-next-line:jsx-use-translation-function*/}
            <span>ERROR ON SIDEBAR</span>
            <button type="button" onClick={errorReload}>
              {/*tslint:disable-next-line:jsx-use-translation-function*/}
              RELOAD
            </button>
          </SideBarWrapper>
        )}
      </>
    );
  }
}

export default React.memo(SidebarError);
